<template>
  <div class="lg:flex px-4 mb-20 lg:mb-30">
    <div class="w-full lg:w-[651px] mr-14">
      <div>
        <div class="text-title text__headline-4-xs--bold lg:text__headline-3-md--bold">
          {{ learnPrivately.title }}
        </div>
      </div>
      <div class="mt-4 lg:mt-6">
        <BaseExpansionDiv
          height-default="max-h-[190px]"
          justify-btn="start"
        >
          <template #content>
            <div class="text-body-1 text__body-2--md--regular" v-html="learnPrivately.description" />
          </template>
        </BaseExpansionDiv>
      </div>
    </div>
    <div class="mx-auto flex justify-center">
      <img
        data-src="@images/public/how-it-work/learn-privately.png"
        class="lazyload mx-auto w-full lg:w-auto lg:h-[314px]"
        :alt="learnPrivately.title"
      >
    </div>
  </div>
</template>
<script>
import staticData from './static-data'

export default {
  name: 'LearnPrivately',
  data () {
    return {
      learnPrivately: staticData.component.LearnPrivately
    }
  },
  computed: {
    showAction () {
      return this.learnPrivately.description && this.learnPrivately.description.length > 450
    }
  }
}
</script>
